export enum GuestbookVisitStatus {
  CheckedIn = "checkedIn",
  RefusedEntry = "refusedEntry",
  Requested = "requested"
}
